export const CARD_REGIST = 'CARD_REGIST'
export const CARD_REGIST_RESULT = 'CARD_REGIST_RESULT'
export const CARD_DELETE_RESULT = 'CARD_DELETE_RESULT'
export const CARD_DELETE = 'CARD_DELETE'
export const CARD_INFO_GET = 'CARD_INFO_GET'
export const CARD_INFO_GET_RESULT = 'CARD_INFO_GET_RESULT'


// WEBPACK FOOTER //
// ./src/constants/User/Credit.js